import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.renderComposable
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.delay
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch

// Koin DI
import org.koin.core.context.startKoin
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject
import di.appModule
import di.composeModule

// Clean Architecture Imports
import presentation.viewmodel.ComposableAppViewModel
import presentation.state.AppState
import ui.theme.ThemeMode
import ui.pages.DashboardPage
import domain.model.PRViewMode

// UI Imports
import ui.theme.*

// External declarations for JavaScript interop
external val window: dynamic

fun main() {
    // Initialize Koin DI
    startKoin {
        modules(appModule, composeModule)
    }
    
    renderComposable(rootElementId = "root") {
        App()
    }
}

@Composable
fun App() {
    // Use Koin to inject the ViewModel
    val viewModel = koinInject<ComposableAppViewModel>()
    val state by viewModel.stateFlow.collectAsState()
    
    val activeTheme = lightTheme
    
    AppThemeProvider(theme = activeTheme) {
        DashboardPage(
            state = state,
            onThemeToggle = { viewModel.changeTheme(ThemeMode.DARK) },
            onSettingsClick = { viewModel.setShowSettingsModal(true) },
            onAddActionClick = { viewModel.setShowAddActionModal(true) },
            onRefresh = { viewModel.refreshPullRequests() },
            onLogout = { viewModel.logout() },
            onViewModeChange = { mode -> viewModel.changeViewMode(mode) },
            onCloseSettings = { viewModel.setShowSettingsModal(false) },
            onRefreshOrganizations = { viewModel.refreshEnhancedFeatures() },
            onCloseAddAction = { viewModel.setShowAddActionModal(false) },
            onSaveAction = { title, description, url, icon -> 
                viewModel.addAction(title, description, url, icon)
                viewModel.setShowAddActionModal(false)
            },
            onCloseTheme = { viewModel.setShowThemeModal(false) },
            onThemeChange = { newTheme -> viewModel.changeTheme(newTheme) }
        )
    }
}

// Compose helper for Koin injection
@Composable
inline fun <reified T> koinInject(): T {
    return remember { 
        object : KoinComponent {
            val value: T by inject()
        }.value
    }
}